import React, { useState } from 'react';
import styled, { createGlobalStyle } from 'styled-components';

import TinaImage from 'components/TinaImage';
import type { ChipBlock as T } from './types';
import Chip from 'components/Chip';
import { blockW } from 'theme/mixins/padding';

const Wrapper = styled.div`
  height: 100vh;
`;

const Container = styled.div`
  text-align: center;
  height: 100%;
  display: grid;
  grid-template-rows: repeat(3, 1fr);
  grid-template-areas:
    '. . .'
    '. . .'
    '. a .';
  position: relative;
  ${({ theme }) => theme.mq.md`
  grid-template-areas:
    '. . .'
    '. a .'
    '. . .';
  `}
`;

const ChipPadding = styled.div`
  display: inline-block;
  padding: 0.25rem;
  ${({ theme }) => theme.mq.md`
    padding: 0.5rem;     
  `}
`;

const ImageContainer = styled.div`
  top: 0;
  left: 0;
  width: 100%;
  position: absolute;
  #cgr {
    height: 90%;
    width: 100%;
    top: 5%;
  }
  #berrien {
    width: 590px;
    height: 90%;
    top: 5%;
  }
  #stone {
    width: 594px;
    height: 334px;
    right: 0px;
    bottom: 3%;
  }
  #racism {
    width: 640px;
    height: 94%;
    top: 3%;
    left: 50%;
    transform: translateX(-50%);
  }
  #speaker {
    width: 696px;
    height: 462px;
    left: 10%;
    top: 5%;
  }
  #trauma {
    width: 590px;
    height: 294px;
    top: 5%;
    right: 3%;
  }
  #talks {
    width: 570px;
    height: 570px;
    left: 0px;
  }
  #covid {
    width: 433.5px;
    height: 339px;
    top: 30%;
    right: 3%;
  }
  #voices {
    width: 534px;
    height: 596px;
    top: 3%;
    left: 25%;
  }
  #blm {
    width: 696px;
    height: 90%;
    top: 5%;
    right: 0px;
  }
  height: 100vh;
  z-index: 1;
  img {
    object-fit: cover;
    width: 100%;
  }
`;

const ChipContainer = styled.div`
  ${blockW()};
  padding: 1rem;
  padding-bottom: 3rem;
  height: 100%;
  position: relative;
  grid-area: a;
  align-self: center;
  justify-self: center;
  z-index: 2;
  ${({ theme }) => theme.mq.md`
    padding: 0.5rem;
    padding-bottom: .5rem;
  `}
`;

const HoverImageWrapper = styled.div<{ show: boolean }>`
  visibility: hidden;
  display: none;
  padding: 0.5rem;
  z-index: 0;
  position: absolute;
  object-fit: cover;

  ${({ theme, show }) => theme.mq.md`
    display:block;
    visibility: ${show ? 'visible' : 'hidden'};
    opacity: ${show ? '1' : '0'};
    transition: opacity .2s linear;
  `}
`;

const LinkedHoverImage = styled(TinaImage)``;

const LinkedMobileHoverImage = styled(TinaImage)<{ show: boolean }>`
  position: absolute;
  display: block;
  width: 100%;
  z-index: 1;
  top: 0;
  object-fit: cover;
  visibility: ${({ show }) => (show ? 'visible' : 'hidden')};
  opacity: ${({ show }) => (show ? '1' : '0')};
  transition: opacity 0.2s linear;
  ${({ theme }) => theme.mq.md`
  display:none;
    visibility: hidden;
  `}
`;

const sections = {
  cgr: {
    title: 'CGR Story'
  },
  berrien: {
    title: 'Berrien County'
  },
  stone: {
    title: 'Death Gap'
  },
  racism: {
    title: 'Racism'
  },
  speaker: {
    title: 'Speaker Series'
  },
  trauma: {
    title: 'Trauma'
  },
  talks: {
    title: 'Brave Talks'
  },
  covid: {
    title: 'Covid-19'
  },
  voices: {
    title: 'Community Voices'
  },
  blm: {
    title: 'Black Lives Matter'
  }
};

const keys = Object.keys(sections);

const ChipBlock: React.FC<T> = () => {
  const [shownImage, setShownImage] = useState('cgr');
  return (
    <Wrapper>
      <Container>
        <ChipContainer>
          {keys.map(key => {
            return (
              <ChipPadding key={key}>
                <Chip
                  onEnter={() => {
                    setShownImage(key);
                  }}
                  active={shownImage == key}
                  text={sections[key as keyof typeof sections].title}
                />
              </ChipPadding>
            );
          })}
        </ChipContainer>
        <ImageContainer>
          {keys.map(key => {
            return (
              <div key={key}>
                <HoverImageWrapper id={`${key}`} show={shownImage == key}>
                  <LinkedHoverImage
                    alt="hover image"
                    src={`/uploads/chip_assets/lg/${key}.jpg`}
                    layout="fill"
                  />
                </HoverImageWrapper>
                <LinkedMobileHoverImage
                  alt="mobile hover image"
                  id={`${key}_mobile`}
                  show={shownImage == key}
                  layout="fill"
                  src={`/uploads/chip_assets/sm/${key}.jpg`}
                />
              </div>
            );
          })}
        </ImageContainer>
      </Container>
    </Wrapper>
  );
};

export default ChipBlock;
